/**
 * HeroLayout - Hero banner layout for event/membership detail pages
 *
 * Features:
 * - Large hero banner image header
 * - Simplified sticky header with title, date/location, and CTA
 * - Single-column content layout (no sidebar)
 *
 * This layout is an alternative to ClassicLayout, selected via:
 * - pageData.layoutPreset = "hero"
 * - Future: useBrandingConfig hook for venue-level settings
 *
 * Note: Site footer is rendered by PublicPage (outside layout) but inside PageThemeProvider.
 */
import { gridSpans } from "@shared/theme/props/grid";
import type { PageData } from "../../adapters/types";
import { LandingPageLayout } from "../shared/LandingPageLayout/LandingPageLayout.web";
import { HeroHeader } from "./sections/HeroHeader.web";
import { HeroStickyHeader } from "./sections/HeroStickyHeader.web";
import { Footer } from "../classic/sections/Footer.web";
import { Modals } from "../classic/sections/Modals.web";
import { Features } from "../classic/sections/Features.web";
import { PageMainContent } from "../shared/MainContent/PageMainContent.web";
import { MainContentBadges } from "../shared/MainContent/MainContentBadges.web";

interface HeroLayoutProps {
  data: PageData;
}

export function HeroLayout({ data }: HeroLayoutProps) {
  return (
    <LandingPageLayout
      modals={<Modals data={data} />}
      features={<Features data={data} />}
      headerContent={<HeroHeader data={data} />}
      stickyHeader={<HeroStickyHeader data={data} />}
      main={
        <PageMainContent
          data={data}
          colSpan={gridSpans.full}
          headerContent={<MainContentBadges data={data} />}
        />
      }
      footer={<Footer data={data} />}
      bg="transparent"
    />
  );
}
